import { ref } from 'vue'
import { defineStore } from 'pinia'

export const useConfigStore = defineStore('config', () => {
  const systemName = ref('EDI')
  const sidebar = ref(true)
  const loading = ref(false)

  const toggleSidebar = () => {
    sidebar.value = !sidebar.value
  }

  const setLoading = (value: boolean) => {
    loading.value = value
  }

  return { systemName, sidebar, loading, toggleSidebar, setLoading }
})
